import { render, staticRenderFns } from "./PresetColorPicker.vue?vue&type=template&id=ad178928&scoped=true"
import script from "./PresetColorPicker.vue?vue&type=script&lang=js"
export * from "./PresetColorPicker.vue?vue&type=script&lang=js"
import style0 from "./PresetColorPicker.vue?vue&type=style&index=0&id=ad178928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad178928",
  null
  
)

export default component.exports